import { Rail } from "@circle-react-uikit/Rail";
import type { ReactNode } from "react";
import { createPortal } from "react-dom";

interface RailBarPortalProps {
  [key: string]: unknown;
  children: ReactNode;
  position?: "header" | "content" | "portal" | "drawer";
  shouldHideRailbarDragger?: boolean;
  shouldShowRailBar?: boolean;
}

export const RailBarPortal = ({
  position = "header",
  children,
  shouldShowRailBar = true,
  shouldHideRailbarDragger = true,
  ...props
}: RailBarPortalProps) => {
  const selectorQuery = `#rail-bar-${position}`;
  const portalElement = document.querySelector(selectorQuery);
  if (!portalElement) {
    return null;
  }

  if (!shouldShowRailBar) {
    return null;
  }

  return (
    <>
      {createPortal(
        <Rail shouldHideRailbarDragger={shouldHideRailbarDragger} {...props}>
          {children}
        </Rail>,
        portalElement,
      )}
    </>
  );
};
